// extracted by mini-css-extract-plugin
export default {"Wrapper":"StepContent_Wrapper__w8Ps+"};